<template>
  <input-widget
          type="select2"
          :attribute="attribute"
          :items="items"
          :disabled="disabled"
          :search-handler="handler"
          :options="options"
          display-field="${item.display_name} - ${item.email}"
          :hint="hint"
          :title-hint="titleHint"
          :label="label"
          :model="model"
          :multiple="multiple"
          @select2Select="onSelect"
          @select2Unselect="onUnselect"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import UserService from "../../modules/setup/user/UserService";

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "UserSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isSearch: {
        type: Boolean,
        default: false,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      filterExtraData: {
        type: Object,
        default() {
          return {};
        },
      },
      options: {
        type: Object,
        default: () => {
          return {minimumInputLength: 3};
        }
      },
      titleHint: {
        type: [Boolean, String],
        default: false
      },
    },
    methods: {
      handler(name) {
        return UserService.getUsersForWidget({...this.filterExtraData, name});
      },
      updateItems() {
        if (this.items.length) {
          return;
        }
        const uuid = this.attribute.substr(this.attribute.length - 5, 5);
        if (uuid === '_uuid' || this.attribute.endsWith('_uuids')) {
          let toListenAttribute = this.attribute.substr(0, this.attribute.length - (this.attribute.endsWith('_uuids') ? 6 : 5));

          if (this.model[toListenAttribute]) {
            this.getSelectedItems(toListenAttribute);
          }

          this.$watch(`model.${this.attribute}`, function () {
            if (this.model[toListenAttribute]) {
              this.getSelectedItems(toListenAttribute);
            } else if (!this.model[this.attribute]) {
              if (this.isSearch) {
                this.items.splice(0, this.items.length);
              } else {
                this.items.length = 0;
              }
            }
          }, {deep: true});
        }
      },
      getSelectedItems(toListenAttribute) {
        if (this.multiple && this.options.multiple) {
          const sourceObjects = this.model[toListenAttribute];
          const currentValues = this.model[this.attribute]

          if (Array.isArray(sourceObjects) && sourceObjects.length > 0 && Array.isArray(currentValues) && currentValues.length > 0) {
            for (let val of currentValues) {
              let tmpObject = sourceObjects.find(o => o.uuid === val)
              let exists = this.items.find(o => o.uuid === val)
              if (tmpObject && !exists) {
                this.items.push(tmpObject);
              }
            }
            return
          }
        }

        const selectedObject = this.model[toListenAttribute];
        let selectedItem = Array.isArray(selectedObject) && selectedObject.length > 0 ? selectedObject[0] : selectedObject;

        if (selectedItem && selectedItem.uuid === this.model[this.attribute]) {
          this.items.push(selectedItem);
        }
      },
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect() {
        this.$emit('unselect');
      }
    },
    mounted() {
      this.updateItems();
    }
  }
</script>

<style scoped>

</style>
